import { useRouter } from '@capsicum/common-web';
import { useWalletFanToken } from '@capsicum/features/wallet/shared';

import { WalletFanTokenListCard } from '../../../ui';

type PartnerBalanceSectionProps = {
	currencyId: string;
	partnerId: string;
};

export const PartnerBalanceSection = ({ currencyId, partnerId }: PartnerBalanceSectionProps) => {
	const { push } = useRouter();
	const { data: fanToken, isLoading } = useWalletFanToken(currencyId);

	const handleRedirect = () => {
		push(`/partner/${partnerId}`);
	};

	return <WalletFanTokenListCard isLoading={isLoading} item={fanToken} onIconClick={handleRedirect} />;
};
